var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"my-2"},[_c('div',[_c('AddCustomerForm',{on:{"closeDialog":function($event){return _vm.$emit('closeDialog')},"submit":_vm.submit}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }